var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"CategoryCard",class:[
    ('bg-' + _vm.color + '-gradient'),
  ],attrs:{"to":_vm.to}},[_c('h3',{staticClass:"CategoryCard_title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"CategoryCard_overview"},[_vm._v(" "+_vm._s(_vm.overview)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }